module.exports = __webpack_public_path__ + "img/ic-facebook.134605ef.svg";